module.exports = __webpack_public_path__ + "img/logoolimpiadas.4ddd881a.png";